import { render, staticRenderFns } from "./BarcodeGeneratePage.vue?vue&type=template&id=383798b7&scoped=true"
import script from "./BarcodeGeneratePage.vue?vue&type=script&lang=js"
export * from "./BarcodeGeneratePage.vue?vue&type=script&lang=js"
import style0 from "./BarcodeGeneratePage.vue?vue&type=style&index=0&id=383798b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383798b7",
  null
  
)

export default component.exports